import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class FileTransferProvider {

  private _service: string = 'payroll';
  private _model: string = 'filetransfer';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public SftpTMB(dataFile: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'SftpTMB';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof dataFile !== 'undefined' && dataFile !== null) _urlParams.dataFile = dataFile;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/file-transfer/file-transfer.ts